import React, { useState } from "react";
import DeleteButton from "@/ui-controls/DeleteButton";
import CancelButton from "@/ui-controls/CancelButton";
import TextInput from "@/ui-controls/TextInput";
import { Grid } from "fluentui-react-grid";
import {
  Privilege,
  deletePrivilege as deletePrivilegeApi,
} from "@/api/privileges";
import { useFormik } from "formik";
import * as Yup from "yup";

interface Props {
  privilege: Privilege;
  onDelete?: (privilege: Privilege) => any;
  onClose?: () => any;
}

const DeleteAppPrivilegeForm = (props: Props) => {
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const deletePrivilege = () => {
    setIsDeleting(true);

    deletePrivilegeApi(props.privilege.Id).then(
      (result: boolean) => {
        setIsDeleting(false);
        if (result) {
          if (props.onDelete) props.onDelete(props.privilege);
        }
      },
      (error) => {
        setIsDeleting(false);
        handleError(error);
      }
    );
  };

  const formik = useFormik({
    initialValues: { name: "" },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Name is required")
        .max(250)
        .oneOf([props.privilege?.Name], "Invalid privilege name"),
    }),
    onSubmit: (values) => {
      deletePrivilege();
    },
  });

  const handleError = (error: any) => {
    // Error handling would go here in real app
  };
  return (
    <>
      {" "}
      <form onSubmit={formik.handleSubmit}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Confirm Privilege Name"
                baseTypeProps={{
                  disabled: isDeleting,
                  ...formik.getFieldProps("name"),
                }}
                hasError={formik.errors.name && formik.touched.name}
                errorMessage={formik.errors.name}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <DeleteButton
                text="Delete"
                baseTypeProps={{ type: "submit", disabled: isDeleting }}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: isDeleting }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </form>
    </>
  );
};

export default DeleteAppPrivilegeForm;
